import React, { useEffect, useRef } from "react";
import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

// Register the ScrollTrigger plugin
gsap.registerPlugin(ScrollTrigger);

export const Services = (props) => {
  const servicesRef = useRef(null);

  useEffect(() => {
    const elements = servicesRef.current.querySelectorAll(".service-card");

    // GSAP animation with ScrollTrigger
    gsap.fromTo(
      elements,
      { y: 50, opacity: 0 }, // Start position (off-screen below)
      {
        y: 0, // Move to original position
        opacity: 1, // Fully visible
        duration: 1, // Animation duration
        ease: "power3.out", // Smooth easing function
        stagger: 0.2, // Stagger animation for each element
        scrollTrigger: {
          trigger: servicesRef.current,
          start: "top 80%", // Trigger when 80% of viewport is visible
          toggleActions: "play none none reset",
        },
      }
    );
  }, []);

  return (
    <div id="services" className="text-center" ref={servicesRef}>
      <div className="container-fluid" style={{ padding: "10px" }}>
        {/* Section Title */}
        <div className="section-title">
          <h2>Our Services</h2>
          <p>
            We offer a comprehensive suite of services and solutions designed to meet the diverse needs of modern businesses.
          </p>
        </div>

        {/* Service Cards */}
        <div className="row">
          {props.data ? (
            props.data.map((d, i) => (
              <div key={`${d.name}-${i}`} className="col-md-3">
                <div className="service-card">
                  {/* Service Icon and Title */}
                  <div style={{ display: "flex", alignItems: "center", marginBottom: "15px" }}>
                    <i className={d.icon}></i>
                    <h3>{d.name}</h3>
                  </div>

                  {/* Service Description */}
                  <p style={{ textAlign: "left" }}>{d.text}</p>

                  {/* Service List (Styled) */}
                  {d.list && (
                    <ul className="service-list" style={{ listStyleType: "disc", paddingLeft: "20px", textAlign: "left", marginLeft: "20px" }}>
                      {d.list.map((item, index) => (
                        <li key={index} style={{ marginBottom: "5px" }}>
                          {item}
                        </li>
                      ))}
                    </ul>
                  )}
                </div>
              </div>
            ))
          ) : (
            "Loading..."
          )}
        </div>
      </div>
    </div>
  );
};